import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import RealityCheckCard from "components/Next/RealityCheck/RealityCheckCard";

import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";

class RealityCheckCardContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <RealityCheckCard {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updatePursuedCount: (runId, pursuedCount, noReset = false) => {
      dispatch(setupReducer.updatePursuedCount(runId, pursuedCount));
      if (ownProps.id !== "new" && !noReset) {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateNotPursuedCount: (runId, notPursuedCount, noReset = false) => {
      dispatch(setupReducer.updateNotPursuedCount(runId, notPursuedCount));
      if (ownProps.id !== "new" && !noReset) {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updatePursuedRatio: (runId, pursuedRatio, noReset = false) => {
      dispatch(setupReducer.updatePursuedRatio(runId, pursuedRatio));
      if (ownProps.id !== "new" && !noReset) {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateNotPursuedRatio: (runId, notPursuedRatio, noReset = false) => {
      dispatch(setupReducer.updateNotPursuedRatio(runId, notPursuedRatio));
      if (ownProps.id !== "new" && !noReset) {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    resetBudget: () => {
      dispatch(projectReducer.resetBudget(ownProps.id));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const runId = ownProps.id;

  return {};
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RealityCheckCardContainer);
